import React, { useLayoutEffect, useState } from 'react'
import { useGetInvoiceQuery } from '../../redux/services/JobService'
import { useParams } from 'react-router-dom'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { Button, Modal } from 'react-bootstrap'
import { FILES_URL } from '../../redux/services/apiConstant'
const InvoicePage = () => {
  const params = useParams()
  const latitude = 24.38756
  const longitude = 25.3876
  const [show, setShow] = useState(false)
  const [previewImg, setPreviewImg] = useState('')
  const [currentStep, setCurrentStep] = React.useState(1)
  const totalSteps = 5

  const showStep = stepNumber => {
    setCurrentStep(stepNumber)
  }
  const handleClose = () => setShow(false)
  const handleShow = url => {
    setPreviewImg(url)
    setShow(true)
  }

  const updateProgress = () => {
    return currentStep === 1 ? 20 : (currentStep / totalSteps) * 100
  }

  const handleTabClick = step => {
    if (step !== currentStep) {
      showStep(step)
    }
  }

  console.log('params', params?.id)

  const { data: data2, isFetching, refetch } = useGetInvoiceQuery({ id: params?.id })

  const drivers = data2?.response?.data

  console.log('data===', drivers)

  const handleOpenGoogleMaps = (lat, lng) => {
    // Construct the Google Maps URL
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`

    // Open the URL in a new tab
    window.open(googleMapsUrl, '_blank')
  }

  useLayoutEffect(() => {
    // JavaScript for Stepper Logic
    document.addEventListener('DOMContentLoaded', function () {
      let currentStep = 1
      const totalSteps = 5
      const progressBar = document.querySelector('.progress-bar')
      const tabItems = document.querySelectorAll('.tab-item')

      // Function to show the current step and hide others
      function showStep(stepNumber) {
        document.querySelectorAll('.step').forEach(step => {
          step.classList.remove('active')
        })
        const newStep = document.getElementById(`step-${stepNumber}`)
        if (newStep) {
          newStep.classList.add('active')
        }
      }

      // Function to update the progress bar
      function updateProgress() {
        if (currentStep === 1) {
          progressBar.style.width = '20%'
          progressBar.innerHTML = `Step 1 of ${totalSteps}`
        } else {
          progressBar.style.width = `${(currentStep / totalSteps) * 100}%`
          progressBar.innerHTML = `Step ${currentStep} of ${totalSteps}`
        }
      }

      // Function to update the active tab style
      function updateActiveTab() {
        tabItems.forEach(tab => {
          tab.classList.remove('active')
          if (parseInt(tab.dataset.step) === currentStep) {
            tab.classList.add('active')
          }
        })
      }

      // Add click listeners to tab items
      tabItems.forEach(tab => {
        tab.addEventListener('click', e => {
          e.preventDefault()
          const step = parseInt(tab.dataset.step)
          if (step !== currentStep) {
            currentStep = step
            showStep(currentStep)
            updateProgress()
            updateActiveTab()
          }
        })
      })

      // Initialize the view
      showStep(currentStep)
      updateProgress()
      updateActiveTab()
    })
  }, [])

  //   const files = [
  //     'https://backend.truklex.com/storage/trip_documents/68c8501473afc.jpeg',
  //     'https://backend.truklex.com/storage/trip_documents/another-file.png',
  //   ]

  const downloadAllFiles = async files => {
    const zip = new JSZip()
    // Fetch all files in parallel
    await Promise.all(
      files.map(async (fileUrl, index) => {
        try {
          const response = await fetch(fileUrl, {
            method: 'GET',
          })
          if (!response.ok) {
            throw new Error('File not found')
          }
          const blob = await response.blob()

          // Add to zip
          zip.file(`file_${index + 1}${fileUrl.slice(fileUrl.lastIndexOf('.'))}`, blob)
        } catch (error) {
          //   console.error('❌ Error fetching file:', error)
        }
      })
    )
    // ✅ Now all files are added, generate zip
    const content = await zip.generateAsync({ type: 'blob' })
    saveAs(content, 'documents.zip')
  }

  if (isFetching) {
    return <>Loading...</>
  }

  return (
    <>
      <div class=' container my-5 d-none'>
        <div class='row'>
          <div class='border bg-white p-4'>
            <div className='row justify-content-between'>
              <div className='col-lg-5'>
                <h4 className='text-primary fw-bold'>
                  {drivers?.company_info?.company_name ?? '-'} &nbsp; (company)
                </h4>
                <div className='row g-2'>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Company Detail/No: <span className='fw-bold'>45688</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      email: <b>{drivers?.company_info?.company_email ?? '-'}</b>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Address <b>{drivers?.factory_company?.address ?? '-'}</b>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      contact no: <b>{drivers?.company_info?.company_phone ?? '-'}</b>
                    </p>
                  </div>
                  <div className='col-lg-12'>
                    <p className='fw-normal text-dark mb-0'>
                      City,State,Zip: &nbsp;
                      <span className='fw-bold'>Karachi,Sindh,4536</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-auto text-end'>
                <h2 className='fw-bold mb-0'>Company ID</h2>
                <p className='fw-bold'>
                  #{drivers?.company_info?.id?.toString()?.padStart(3, '0') ?? '-'}
                </p>
              </div>
            </div>
            <hr />
            <div className='row justify-content-between'>
              <div className='col-lg-5'>
                <h4 className='text-primary fw-bold'>
                  {drivers?.driver?.full_name ?? '-'} &nbsp;
                  <span className='h5 fw-bold'>(Driver)</span>
                </h4>
                <div className='row g-2'>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      DL Number: <span className='fw-bold'>{drivers?.driver?.dln ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Email: <b>{drivers?.driver?.email ?? '-'}</b>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Address: <b>{drivers?.driver?.address_1 ?? '-'}</b>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Conatact no: <b>{drivers?.driver?.phone ?? '-'}</b>
                    </p>
                  </div>
                  <div className='col-lg-12'>
                    <p className='fw-normal text-dark mb-0'>
                      City,State,Zip: &nbsp;
                      <span className='fw-bold'>
                        {drivers?.driver?.city ?? '-'},{drivers?.driver?.state ?? '-'},
                        {drivers?.driver?.zip_code ?? '-'}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-auto text-end'>
                <h2 className='fw-bold mb-0'>Driver ID</h2>
                <p className='fw-bold'>
                  #{drivers?.driver?.id?.toString()?.padStart(3, '0') ?? '-'}
                </p>
              </div>
            </div>
            <hr />
            <div className='row'>
              <div className='col-lg-5'>
                <h4 className='text-primary fw-bold'>
                  {drivers?.broker?.broker_name ?? '-'} &nbsp;
                  <span className='h5 fw-bold'>(Broker)</span>
                </h4>
                <div className='row g-2'>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Email: <span className='fw-bold'>{drivers?.broker?.broker_email ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Phone: <span className='fw-bold'>{drivers?.broker?.phone_number ?? '-'}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className='row'>
              <div className='col-lg-5'>
                <h4 className='text-primary fw-bold'>
                  {drivers?.factory_company?.company_name ?? '-'} &nbsp;
                  <span className='h5 fw-bold'>(Factoring Company)</span>
                </h4>
                <div className='row g-2'>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Email:{' '}
                      <span className='fw-bold'>{drivers?.factory_company?.email ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Phone:{' '}
                      <span className='fw-bold'>{drivers?.factory_company?.phone ?? '-'}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className='row'>
              <div className='col-lg-7'>
                <h4 className='text-primary fw-bold'>
                  Job Name &nbsp;
                  <span className='h5 fw-bold'>(Job Detail)</span>
                </h4>
                <div className='row g-2'>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      TRANSIT: <span className='fw-bold'>{drivers?.transit ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      EMPTYREΡΟ: <span className='fw-bold'>{drivers?.emptyrepo ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Job Amount: <span className='fw-bold'>{drivers?.job_amount ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Estimated Miles:{' '}
                      <span className='fw-bold'>{drivers?.estimated_miles ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Estimated Dollar Per Mile:{' '}
                      <span className='fw-bold'>{drivers?.estimated_dollar_per_mile ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Job Start Date & Time:{' '}
                      <span className='fw-bold'>{drivers?.job_start_datetime}</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Job End Date & Time: <span className='fw-bold'>30-06-2025 16:28</span>
                    </p>
                  </div>
                </div>
                <hr />
                <h4 className='text-primary fw-bold'>Rate Confirmation &nbsp;</h4>
                {drivers?.rate_confirmation_document && (
                  <a
                    href={drivers?.rate_confirmation_document_url || void 0}
                    type='button'
                    target='_blank'
                    className='row g-2 align-items-center'
                  >
                    <div className='col-auto'>
                      <svg
                        version='1.1'
                        id='_x34_'
                        xmlns='http://www.w3.org/2000/svg'
                        xmlnsXlink='http://www.w3.org/1999/xlink'
                        viewBox='0 0 512 512'
                        xmlSpace='preserve'
                        width='64px'
                        height='64px'
                        fill='#000000'
                      >
                        <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                        <g
                          id='SVGRepo_tracerCarrier'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <g id='SVGRepo_iconCarrier'>
                          {' '}
                          <g>
                            {' '}
                            <polygon
                              style={{ fill: '#FFFEFE' }}
                              points='475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 '
                            />{' '}
                            <rect
                              x='36.565'
                              y='34.295'
                              style={{ fill: '#B43331' }}
                              width='205.097'
                              height='91.768'
                            />{' '}
                            <g>
                              {' '}
                              <g>
                                {' '}
                                <path
                                  style={{ fill: '#FFFEFE' }}
                                  d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                                />{' '}
                                <path
                                  style={{ fill: '#FFFEFE' }}
                                  d='M164.558,75.761c-0.075-2.035-0.15-3.844-0.377-5.503c-0.225-1.659-0.603-3.166-1.131-4.598 c-0.527-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.522-5.126-7.312-6.483c-2.864-1.357-6.256-2.035-10.252-2.035H122.42v58.195 h20.956c3.996,0,7.388-0.678,10.252-2.035c2.79-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.584-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.227-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.15,3.091-0.302,4.297 c-0.151,1.131-0.376,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.668V63.323 h8.668c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186c0.302,0.829,0.528,1.809,0.678,3.015 c0.152,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z'
                                />{' '}
                                <path
                                  style={{ fill: '#FFFEFE' }}
                                  d='M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z'
                                />{' '}
                              </g>{' '}
                              <g>
                                {' '}
                                <path
                                  style={{ fill: '#FFFEFE' }}
                                  d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                                />{' '}
                              </g>{' '}
                            </g>{' '}
                            <polygon
                              style={{ opacity: '0.08', fill: '#040000' }}
                              points='475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.706,219.667 259.541,207.832 266.099,201.273 277.029,190.343 289.995,177.377 412.491,54.881 '
                            />{' '}
                            <polygon
                              style={{ fill: '#BBBBBA' }}
                              points='475.435,117.836 357.6,117.836 357.6,0 '
                            />{' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#B43331' }}
                                d='M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.543-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.996-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.583-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.83-9.046-2.036-13.117 c-1.808-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.15-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.802,11.76c-6.331,7.538-9.724,17.866-9.875,30.002c-0.225,18.544,1.282,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.871,41.611c-7.086,14.398-14.248,26.836-19.222,35.279 c-3.769,6.408-7.916,13.117-12.213,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.374,7.011-34.903,16.056-46.059,26.836 c-7.238,6.935-12.137,14.323-14.55,22.012c-2.563,7.915-2.411,15.83,0.453,22.916c2.638,6.558,7.387,12.061,13.719,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.102,3.015,15.604,3.015c12.74,0,25.856-5.503,36.938-15.378 c20.654-18.469,41.988-48.169,54.576-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.927-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.63,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.15,0.075 c5.127,3.392,10.026,6.181,14.926,8.443c5.502,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.181,387.694,418.899,378.724,414.376,370.658z M247.706,219.667 c-1.056-9.348-1.508-19.072-1.357-29.324c0.15-9.724,3.694-16.283,8.895-16.283c3.919,0,8.066,3.543,9.951,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.15,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.112,19.75-4.976,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.706,219.667z M121.968,418.073 c-1.282-3.166,0.15-9.272,7.99-16.81c11.985-11.458,30.755-20.504,56.914-27.364c-4.976,6.784-9.875,12.966-14.625,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.351,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.169,423.049,123.173,421.089,121.968,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.15-0.377,0.377-0.754,0.602-1.055c3.167-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.735,2.035,3.544,3.995,5.352,5.955l-1.205,0.075l1.055,0.98 c-3.09,0.226-6.331,0.528-9.573,0.829c-2.036,0.226-4.147,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.298,384.98c-8.97-5.729-18.997-13.795-31.36-24.575c17.564,1.809,31.36,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.619,3.844,4.901,7.312,4.221,9.649c-0.602,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.879-1.432c-3.468-1.658-7.086-3.694-10.931-6.181C369.598,385.282,369.448,385.131,369.298,384.98z'
                              />{' '}
                            </g>{' '}
                          </g>{' '}
                        </g>
                      </svg>
                    </div>
                    <div className='col-lg'>
                      <h5 className='fw-bold text-dark mb-0'>
                        {
                          drivers?.rate_confirmation_document?.split('/')[
                            drivers?.rate_confirmation_document?.split('/')?.length - 1
                          ]
                        }
                      </h5>
                    </div>
                  </a>
                )}
              </div>
              <div className='col-lg-5 border-start'>
                <h4 className='text-primary fw-bold'>
                  Time Stamps &nbsp;
                  <span className='h5 fw-bold'>{/*(Job Detail)*/}</span>
                </h4>
                <div className='row g-2'>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Start TS: <span className='fw-bold'>25-06-2025 16:28</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      End TS: <span className='fw-bold'>30-06-2025 16:28</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup TS: <span className='fw-bold'>30-06-2025 16:28</span>
                    </p>
                  </div>
                  <div className='col-lg-6'>
                    <p className='fw-normal text-dark mb-0'>
                      Dropoff TS: <span className='fw-bold'>30-06-2025 16:28</span>
                    </p>
                  </div>
                </div>

                <h4 className='text-primary fw-bold mt-3'>Pickup &nbsp;</h4>
                <div class='row g-2'>
                  <div className='col-lg-12'>
                    <p className='fw-normal text-dark mb-0'>
                      Coordinates:{' '}
                      <span className='fw-bold'>
                        {drivers?.pickup_latitude}, {drivers?.pickup_longitude}
                      </span>
                      <br />
                      <a
                        href={void 0}
                        onClick={() =>
                          handleOpenGoogleMaps(drivers?.pickup_latitude, drivers?.pickup_longitude)
                        }
                        className='d-inline-block'
                        type='button'
                      >
                        Open on Google Maps
                      </a>
                    </p>
                  </div>
                </div>

                <h4 className='text-primary fw-bold mt-3'>Dropoff &nbsp;</h4>
                <div class='row g-2'>
                  <div className='col-lg-12'>
                    <p className='fw-normal text-dark mb-0'>
                      Coordinates:{' '}
                      <span className='fw-bold'>
                        {drivers?.drop_latitude}, {drivers?.drop_longitude}
                      </span>
                      <br />
                      <a
                        href={void 0}
                        onClick={() =>
                          handleOpenGoogleMaps(drivers?.drop_latitude, drivers?.drop_longitude)
                        }
                        className='d-inline-block'
                        type='button'
                      >
                        Open on Google Maps
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className='row'>
              <div className='col-lg-12'>
                <h4 className='text-primary fw-bold'>Shipper or Pick Up Detail</h4>
                <div className='row g-2 justify-content-between'>
                  <div className='col-lg-5'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup Date & Time: &nbsp;
                      <b>25-06-2025 23:38</b>
                    </p>
                  </div>

                  <div className='col-lg-auto'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup Facility Ref Name:{' '}
                      <span className='fw-bold'>{drivers?.pickup_person_name ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-auto'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup Facility Ref Contact:{' '}
                      <span className='fw-bold'>{drivers?.pickup_person_phone ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-12'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup Address: &nbsp;
                      <b>{drivers?.pickup_address ?? '-'}</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h6 className='text-primary fw-bold my-2'>Required Documents on Pick Up</h6>
            <div className='row justify-content-between'>
              <div className='col-lg-4'>
                <div className='row g-2 align-items-center'>
                  <div className='col-auto'>
                    <svg
                      version='1.1'
                      id='_x34_'
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                      width='64px'
                      height='64px'
                      fill='#000000'
                    >
                      <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                      <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
                      <g id='SVGRepo_iconCarrier'>
                        {' '}
                        <g>
                          {' '}
                          <polygon
                            style={{ fill: '#FFFEFE' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 '
                          />{' '}
                          <rect
                            x='36.565'
                            y='34.295'
                            style={{ fill: '#B43331' }}
                            width='205.097'
                            height='91.768'
                          />{' '}
                          <g>
                            {' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M164.558,75.761c-0.075-2.035-0.15-3.844-0.377-5.503c-0.225-1.659-0.603-3.166-1.131-4.598 c-0.527-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.522-5.126-7.312-6.483c-2.864-1.357-6.256-2.035-10.252-2.035H122.42v58.195 h20.956c3.996,0,7.388-0.678,10.252-2.035c2.79-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.584-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.227-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.15,3.091-0.302,4.297 c-0.151,1.131-0.376,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.668V63.323 h8.668c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186c0.302,0.829,0.528,1.809,0.678,3.015 c0.152,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z'
                              />{' '}
                            </g>{' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                            </g>{' '}
                          </g>{' '}
                          <polygon
                            style={{ opacity: '0.08', fill: '#040000' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.706,219.667 259.541,207.832 266.099,201.273 277.029,190.343 289.995,177.377 412.491,54.881 '
                          />{' '}
                          <polygon
                            style={{ fill: '#BBBBBA' }}
                            points='475.435,117.836 357.6,117.836 357.6,0 '
                          />{' '}
                          <g>
                            {' '}
                            <path
                              style={{ fill: '#B43331' }}
                              d='M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.543-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.996-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.583-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.83-9.046-2.036-13.117 c-1.808-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.15-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.802,11.76c-6.331,7.538-9.724,17.866-9.875,30.002c-0.225,18.544,1.282,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.871,41.611c-7.086,14.398-14.248,26.836-19.222,35.279 c-3.769,6.408-7.916,13.117-12.213,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.374,7.011-34.903,16.056-46.059,26.836 c-7.238,6.935-12.137,14.323-14.55,22.012c-2.563,7.915-2.411,15.83,0.453,22.916c2.638,6.558,7.387,12.061,13.719,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.102,3.015,15.604,3.015c12.74,0,25.856-5.503,36.938-15.378 c20.654-18.469,41.988-48.169,54.576-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.927-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.63,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.15,0.075 c5.127,3.392,10.026,6.181,14.926,8.443c5.502,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.181,387.694,418.899,378.724,414.376,370.658z M247.706,219.667 c-1.056-9.348-1.508-19.072-1.357-29.324c0.15-9.724,3.694-16.283,8.895-16.283c3.919,0,8.066,3.543,9.951,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.15,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.112,19.75-4.976,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.706,219.667z M121.968,418.073 c-1.282-3.166,0.15-9.272,7.99-16.81c11.985-11.458,30.755-20.504,56.914-27.364c-4.976,6.784-9.875,12.966-14.625,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.351,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.169,423.049,123.173,421.089,121.968,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.15-0.377,0.377-0.754,0.602-1.055c3.167-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.735,2.035,3.544,3.995,5.352,5.955l-1.205,0.075l1.055,0.98 c-3.09,0.226-6.331,0.528-9.573,0.829c-2.036,0.226-4.147,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.298,384.98c-8.97-5.729-18.997-13.795-31.36-24.575c17.564,1.809,31.36,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.619,3.844,4.901,7.312,4.221,9.649c-0.602,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.879-1.432c-3.468-1.658-7.086-3.694-10.931-6.181C369.598,385.282,369.448,385.131,369.298,384.98z'
                            />{' '}
                          </g>{' '}
                        </g>{' '}
                      </g>
                    </svg>
                  </div>
                  <div className='col-lg'>
                    <h5 className='fw-bold text-dark mb-0'>Order-Document.pdf</h5>
                  </div>
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='row g-2 align-items-center'>
                  <div className='col-auto'>
                    <svg
                      version='1.1'
                      id='_x34_'
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                      width='64px'
                      height='64px'
                      fill='#000000'
                    >
                      <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                      <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
                      <g id='SVGRepo_iconCarrier'>
                        {' '}
                        <g>
                          {' '}
                          <polygon
                            style={{ fill: '#FFFEFE' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 '
                          />{' '}
                          <rect
                            x='36.565'
                            y='34.295'
                            style={{ fill: '#B43331' }}
                            width='205.097'
                            height='91.768'
                          />{' '}
                          <g>
                            {' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M164.558,75.761c-0.075-2.035-0.15-3.844-0.377-5.503c-0.225-1.659-0.603-3.166-1.131-4.598 c-0.527-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.522-5.126-7.312-6.483c-2.864-1.357-6.256-2.035-10.252-2.035H122.42v58.195 h20.956c3.996,0,7.388-0.678,10.252-2.035c2.79-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.584-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.227-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.15,3.091-0.302,4.297 c-0.151,1.131-0.376,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.668V63.323 h8.668c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186c0.302,0.829,0.528,1.809,0.678,3.015 c0.152,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z'
                              />{' '}
                            </g>{' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                            </g>{' '}
                          </g>{' '}
                          <polygon
                            style={{ opacity: '0.08', fill: '#040000' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.706,219.667 259.541,207.832 266.099,201.273 277.029,190.343 289.995,177.377 412.491,54.881 '
                          />{' '}
                          <polygon
                            style={{ fill: '#BBBBBA' }}
                            points='475.435,117.836 357.6,117.836 357.6,0 '
                          />{' '}
                          <g>
                            {' '}
                            <path
                              style={{ fill: '#B43331' }}
                              d='M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.543-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.996-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.583-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.83-9.046-2.036-13.117 c-1.808-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.15-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.802,11.76c-6.331,7.538-9.724,17.866-9.875,30.002c-0.225,18.544,1.282,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.871,41.611c-7.086,14.398-14.248,26.836-19.222,35.279 c-3.769,6.408-7.916,13.117-12.213,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.374,7.011-34.903,16.056-46.059,26.836 c-7.238,6.935-12.137,14.323-14.55,22.012c-2.563,7.915-2.411,15.83,0.453,22.916c2.638,6.558,7.387,12.061,13.719,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.102,3.015,15.604,3.015c12.74,0,25.856-5.503,36.938-15.378 c20.654-18.469,41.988-48.169,54.576-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.927-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.63,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.15,0.075 c5.127,3.392,10.026,6.181,14.926,8.443c5.502,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.181,387.694,418.899,378.724,414.376,370.658z M247.706,219.667 c-1.056-9.348-1.508-19.072-1.357-29.324c0.15-9.724,3.694-16.283,8.895-16.283c3.919,0,8.066,3.543,9.951,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.15,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.112,19.75-4.976,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.706,219.667z M121.968,418.073 c-1.282-3.166,0.15-9.272,7.99-16.81c11.985-11.458,30.755-20.504,56.914-27.364c-4.976,6.784-9.875,12.966-14.625,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.351,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.169,423.049,123.173,421.089,121.968,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.15-0.377,0.377-0.754,0.602-1.055c3.167-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.735,2.035,3.544,3.995,5.352,5.955l-1.205,0.075l1.055,0.98 c-3.09,0.226-6.331,0.528-9.573,0.829c-2.036,0.226-4.147,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.298,384.98c-8.97-5.729-18.997-13.795-31.36-24.575c17.564,1.809,31.36,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.619,3.844,4.901,7.312,4.221,9.649c-0.602,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.879-1.432c-3.468-1.658-7.086-3.694-10.931-6.181C369.598,385.282,369.448,385.131,369.298,384.98z'
                            />{' '}
                          </g>{' '}
                        </g>{' '}
                      </g>
                    </svg>
                  </div>
                  <div className='col-lg'>
                    <h5 className='fw-bold text-dark mb-0'>Order-Document.pdf</h5>
                  </div>
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='row g-2 align-items-center'>
                  <div className='col-auto'>
                    <svg
                      version='1.1'
                      id='_x34_'
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                      width='64px'
                      height='64px'
                      fill='#000000'
                    >
                      <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                      <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
                      <g id='SVGRepo_iconCarrier'>
                        {' '}
                        <g>
                          {' '}
                          <polygon
                            style={{ fill: '#FFFEFE' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 '
                          />{' '}
                          <rect
                            x='36.565'
                            y='34.295'
                            style={{ fill: '#B43331' }}
                            width='205.097'
                            height='91.768'
                          />{' '}
                          <g>
                            {' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M164.558,75.761c-0.075-2.035-0.15-3.844-0.377-5.503c-0.225-1.659-0.603-3.166-1.131-4.598 c-0.527-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.522-5.126-7.312-6.483c-2.864-1.357-6.256-2.035-10.252-2.035H122.42v58.195 h20.956c3.996,0,7.388-0.678,10.252-2.035c2.79-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.584-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.227-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.15,3.091-0.302,4.297 c-0.151,1.131-0.376,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.668V63.323 h8.668c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186c0.302,0.829,0.528,1.809,0.678,3.015 c0.152,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z'
                              />{' '}
                            </g>{' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                            </g>{' '}
                          </g>{' '}
                          <polygon
                            style={{ opacity: '0.08', fill: '#040000' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.706,219.667 259.541,207.832 266.099,201.273 277.029,190.343 289.995,177.377 412.491,54.881 '
                          />{' '}
                          <polygon
                            style={{ fill: '#BBBBBA' }}
                            points='475.435,117.836 357.6,117.836 357.6,0 '
                          />{' '}
                          <g>
                            {' '}
                            <path
                              style={{ fill: '#B43331' }}
                              d='M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.543-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.996-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.583-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.83-9.046-2.036-13.117 c-1.808-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.15-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.802,11.76c-6.331,7.538-9.724,17.866-9.875,30.002c-0.225,18.544,1.282,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.871,41.611c-7.086,14.398-14.248,26.836-19.222,35.279 c-3.769,6.408-7.916,13.117-12.213,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.374,7.011-34.903,16.056-46.059,26.836 c-7.238,6.935-12.137,14.323-14.55,22.012c-2.563,7.915-2.411,15.83,0.453,22.916c2.638,6.558,7.387,12.061,13.719,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.102,3.015,15.604,3.015c12.74,0,25.856-5.503,36.938-15.378 c20.654-18.469,41.988-48.169,54.576-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.927-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.63,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.15,0.075 c5.127,3.392,10.026,6.181,14.926,8.443c5.502,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.181,387.694,418.899,378.724,414.376,370.658z M247.706,219.667 c-1.056-9.348-1.508-19.072-1.357-29.324c0.15-9.724,3.694-16.283,8.895-16.283c3.919,0,8.066,3.543,9.951,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.15,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.112,19.75-4.976,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.706,219.667z M121.968,418.073 c-1.282-3.166,0.15-9.272,7.99-16.81c11.985-11.458,30.755-20.504,56.914-27.364c-4.976,6.784-9.875,12.966-14.625,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.351,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.169,423.049,123.173,421.089,121.968,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.15-0.377,0.377-0.754,0.602-1.055c3.167-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.735,2.035,3.544,3.995,5.352,5.955l-1.205,0.075l1.055,0.98 c-3.09,0.226-6.331,0.528-9.573,0.829c-2.036,0.226-4.147,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.298,384.98c-8.97-5.729-18.997-13.795-31.36-24.575c17.564,1.809,31.36,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.619,3.844,4.901,7.312,4.221,9.649c-0.602,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.879-1.432c-3.468-1.658-7.086-3.694-10.931-6.181C369.598,385.282,369.448,385.131,369.298,384.98z'
                            />{' '}
                          </g>{' '}
                        </g>{' '}
                      </g>
                    </svg>
                  </div>
                  <div className='col-lg'>
                    <h5 className='fw-bold text-dark mb-0'>Order-Document.pdf</h5>
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <div className='row'>
              <div className='col-lg-12'>
                <h4 className='text-primary fw-bold'>Reciever or DropOff Detail</h4>
                <div className='row g-2 justify-content-between'>
                  <div className='col-lg-5'>
                    <p className='fw-normal text-dark mb-0'>
                      DropOff Date & Time: &nbsp;
                      <b>{drivers?.drop_datetime ?? '-'}</b>
                    </p>
                  </div>

                  <div className='col-lg-auto'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup Facility Ref Name:{' '}
                      <span className='fw-bold'>{drivers?.drop_person_name ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-auto'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup Facility Ref Contact:{' '}
                      <span className='fw-bold'>{drivers?.pickup_person_phone ?? '-'}</span>
                    </p>
                  </div>
                  <div className='col-lg-12'>
                    <p className='fw-normal text-dark mb-0'>
                      Pickup Address: &nbsp;
                      <b>{drivers?.drop_address ?? '-'}</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h6 className='text-primary fw-bold my-2'>Required Documents on Dropoff</h6>
            <div className='row justify-content-between'>
              <div className='col-lg-4'>
                <div className='row g-2 align-items-center'>
                  <div className='col-auto'>
                    <svg
                      version='1.1'
                      id='_x34_'
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                      width='64px'
                      height='64px'
                      fill='#000000'
                    >
                      <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                      <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
                      <g id='SVGRepo_iconCarrier'>
                        {' '}
                        <g>
                          {' '}
                          <polygon
                            style={{ fill: '#FFFEFE' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 '
                          />{' '}
                          <rect
                            x='36.565'
                            y='34.295'
                            style={{ fill: '#B43331' }}
                            width='205.097'
                            height='91.768'
                          />{' '}
                          <g>
                            {' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M164.558,75.761c-0.075-2.035-0.15-3.844-0.377-5.503c-0.225-1.659-0.603-3.166-1.131-4.598 c-0.527-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.522-5.126-7.312-6.483c-2.864-1.357-6.256-2.035-10.252-2.035H122.42v58.195 h20.956c3.996,0,7.388-0.678,10.252-2.035c2.79-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.584-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.227-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.15,3.091-0.302,4.297 c-0.151,1.131-0.376,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.668V63.323 h8.668c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186c0.302,0.829,0.528,1.809,0.678,3.015 c0.152,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z'
                              />{' '}
                            </g>{' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                            </g>{' '}
                          </g>{' '}
                          <polygon
                            style={{ opacity: '0.08', fill: '#040000' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.706,219.667 259.541,207.832 266.099,201.273 277.029,190.343 289.995,177.377 412.491,54.881 '
                          />{' '}
                          <polygon
                            style={{ fill: '#BBBBBA' }}
                            points='475.435,117.836 357.6,117.836 357.6,0 '
                          />{' '}
                          <g>
                            {' '}
                            <path
                              style={{ fill: '#B43331' }}
                              d='M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.543-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.996-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.583-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.83-9.046-2.036-13.117 c-1.808-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.15-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.802,11.76c-6.331,7.538-9.724,17.866-9.875,30.002c-0.225,18.544,1.282,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.871,41.611c-7.086,14.398-14.248,26.836-19.222,35.279 c-3.769,6.408-7.916,13.117-12.213,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.374,7.011-34.903,16.056-46.059,26.836 c-7.238,6.935-12.137,14.323-14.55,22.012c-2.563,7.915-2.411,15.83,0.453,22.916c2.638,6.558,7.387,12.061,13.719,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.102,3.015,15.604,3.015c12.74,0,25.856-5.503,36.938-15.378 c20.654-18.469,41.988-48.169,54.576-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.927-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.63,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.15,0.075 c5.127,3.392,10.026,6.181,14.926,8.443c5.502,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.181,387.694,418.899,378.724,414.376,370.658z M247.706,219.667 c-1.056-9.348-1.508-19.072-1.357-29.324c0.15-9.724,3.694-16.283,8.895-16.283c3.919,0,8.066,3.543,9.951,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.15,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.112,19.75-4.976,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.706,219.667z M121.968,418.073 c-1.282-3.166,0.15-9.272,7.99-16.81c11.985-11.458,30.755-20.504,56.914-27.364c-4.976,6.784-9.875,12.966-14.625,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.351,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.169,423.049,123.173,421.089,121.968,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.15-0.377,0.377-0.754,0.602-1.055c3.167-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.735,2.035,3.544,3.995,5.352,5.955l-1.205,0.075l1.055,0.98 c-3.09,0.226-6.331,0.528-9.573,0.829c-2.036,0.226-4.147,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.298,384.98c-8.97-5.729-18.997-13.795-31.36-24.575c17.564,1.809,31.36,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.619,3.844,4.901,7.312,4.221,9.649c-0.602,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.879-1.432c-3.468-1.658-7.086-3.694-10.931-6.181C369.598,385.282,369.448,385.131,369.298,384.98z'
                            />{' '}
                          </g>{' '}
                        </g>{' '}
                      </g>
                    </svg>
                  </div>
                  <div className='col-lg'>
                    <h5 className='fw-bold text-dark mb-0'>Order-Document.pdf</h5>
                  </div>
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='row g-2 align-items-center'>
                  <div className='col-auto'>
                    <svg
                      version='1.1'
                      id='_x34_'
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                      width='64px'
                      height='64px'
                      fill='#000000'
                    >
                      <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                      <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
                      <g id='SVGRepo_iconCarrier'>
                        {' '}
                        <g>
                          {' '}
                          <polygon
                            style={{ fill: '#FFFEFE' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 '
                          />{' '}
                          <rect
                            x='36.565'
                            y='34.295'
                            style={{ fill: '#B43331' }}
                            width='205.097'
                            height='91.768'
                          />{' '}
                          <g>
                            {' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M164.558,75.761c-0.075-2.035-0.15-3.844-0.377-5.503c-0.225-1.659-0.603-3.166-1.131-4.598 c-0.527-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.522-5.126-7.312-6.483c-2.864-1.357-6.256-2.035-10.252-2.035H122.42v58.195 h20.956c3.996,0,7.388-0.678,10.252-2.035c2.79-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.584-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.227-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.15,3.091-0.302,4.297 c-0.151,1.131-0.376,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.668V63.323 h8.668c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186c0.302,0.829,0.528,1.809,0.678,3.015 c0.152,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z'
                              />{' '}
                            </g>{' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                            </g>{' '}
                          </g>{' '}
                          <polygon
                            style={{ opacity: '0.08', fill: '#040000' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.706,219.667 259.541,207.832 266.099,201.273 277.029,190.343 289.995,177.377 412.491,54.881 '
                          />{' '}
                          <polygon
                            style={{ fill: '#BBBBBA' }}
                            points='475.435,117.836 357.6,117.836 357.6,0 '
                          />{' '}
                          <g>
                            {' '}
                            <path
                              style={{ fill: '#B43331' }}
                              d='M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.543-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.996-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.583-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.83-9.046-2.036-13.117 c-1.808-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.15-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.802,11.76c-6.331,7.538-9.724,17.866-9.875,30.002c-0.225,18.544,1.282,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.871,41.611c-7.086,14.398-14.248,26.836-19.222,35.279 c-3.769,6.408-7.916,13.117-12.213,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.374,7.011-34.903,16.056-46.059,26.836 c-7.238,6.935-12.137,14.323-14.55,22.012c-2.563,7.915-2.411,15.83,0.453,22.916c2.638,6.558,7.387,12.061,13.719,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.102,3.015,15.604,3.015c12.74,0,25.856-5.503,36.938-15.378 c20.654-18.469,41.988-48.169,54.576-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.927-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.63,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.15,0.075 c5.127,3.392,10.026,6.181,14.926,8.443c5.502,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.181,387.694,418.899,378.724,414.376,370.658z M247.706,219.667 c-1.056-9.348-1.508-19.072-1.357-29.324c0.15-9.724,3.694-16.283,8.895-16.283c3.919,0,8.066,3.543,9.951,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.15,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.112,19.75-4.976,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.706,219.667z M121.968,418.073 c-1.282-3.166,0.15-9.272,7.99-16.81c11.985-11.458,30.755-20.504,56.914-27.364c-4.976,6.784-9.875,12.966-14.625,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.351,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.169,423.049,123.173,421.089,121.968,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.15-0.377,0.377-0.754,0.602-1.055c3.167-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.735,2.035,3.544,3.995,5.352,5.955l-1.205,0.075l1.055,0.98 c-3.09,0.226-6.331,0.528-9.573,0.829c-2.036,0.226-4.147,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.298,384.98c-8.97-5.729-18.997-13.795-31.36-24.575c17.564,1.809,31.36,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.619,3.844,4.901,7.312,4.221,9.649c-0.602,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.879-1.432c-3.468-1.658-7.086-3.694-10.931-6.181C369.598,385.282,369.448,385.131,369.298,384.98z'
                            />{' '}
                          </g>{' '}
                        </g>{' '}
                      </g>
                    </svg>
                  </div>
                  <div className='col-lg'>
                    <h5 className='fw-bold text-dark mb-0'>Order-Document.pdf</h5>
                  </div>
                </div>
              </div>
              <div className='col-lg-4'>
                <div className='row g-2 align-items-center'>
                  <div className='col-auto'>
                    <svg
                      version='1.1'
                      id='_x34_'
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      viewBox='0 0 512 512'
                      xmlSpace='preserve'
                      width='64px'
                      height='64px'
                      fill='#000000'
                    >
                      <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                      <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
                      <g id='SVGRepo_iconCarrier'>
                        {' '}
                        <g>
                          {' '}
                          <polygon
                            style={{ fill: '#FFFEFE' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,0.002 357.613,0.002 412.491,54.881 '
                          />{' '}
                          <rect
                            x='36.565'
                            y='34.295'
                            style={{ fill: '#B43331' }}
                            width='205.097'
                            height='91.768'
                          />{' '}
                          <g>
                            {' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M164.558,75.761c-0.075-2.035-0.15-3.844-0.377-5.503c-0.225-1.659-0.603-3.166-1.131-4.598 c-0.527-1.357-1.206-2.714-2.111-3.92c-2.035-2.94-4.522-5.126-7.312-6.483c-2.864-1.357-6.256-2.035-10.252-2.035H122.42v58.195 h20.956c3.996,0,7.388-0.678,10.252-2.035c2.79-1.357,5.277-3.543,7.312-6.483c0.905-1.206,1.584-2.563,2.111-3.92 c0.528-1.432,0.905-2.94,1.131-4.598c0.227-1.658,0.301-3.468,0.377-5.503c0.075-1.96,0.075-4.146,0.075-6.558 C164.633,79.908,164.633,77.721,164.558,75.761z M153.175,88.2c0,1.734-0.15,3.091-0.302,4.297 c-0.151,1.131-0.376,2.186-0.678,2.94c-0.301,0.829-0.754,1.583-1.281,2.261c-1.885,2.412-4.749,3.543-8.518,3.543h-8.668V63.323 h8.668c3.769,0,6.634,1.206,8.518,3.618c0.528,0.678,0.98,1.357,1.281,2.186c0.302,0.829,0.528,1.809,0.678,3.015 c0.152,1.131,0.302,2.563,0.302,4.221c0.075,1.659,0.075,3.694,0.075,5.955C153.251,84.581,153.251,86.541,153.175,88.2z'
                              />{' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M213.18,63.323V53.222h-38.37v58.195h11.383V87.823h22.992V77.646h-22.992V63.323H213.18z'
                              />{' '}
                            </g>{' '}
                            <g>
                              {' '}
                              <path
                                style={{ fill: '#FFFEFE' }}
                                d='M110.133,64.379c-0.905-2.186-2.111-4.146-3.769-5.804c-1.659-1.658-3.694-3.015-6.031-3.92 c-2.412-0.98-5.127-1.432-8.141-1.432H69.652v58.195h11.383V89.481h11.157c3.015,0,5.729-0.452,8.141-1.432 c2.337-0.905,4.371-2.261,6.031-3.92c1.658-1.658,2.865-3.543,3.769-5.804c0.828-2.186,1.281-4.523,1.281-6.935 C111.413,68.902,110.961,66.565,110.133,64.379z M97.845,77.118c-1.508,1.432-3.618,2.186-6.182,2.186H81.035V63.323h10.628 c2.564,0,4.674,0.754,6.182,2.261c1.432,1.432,2.185,3.392,2.185,5.804C100.031,73.726,99.277,75.686,97.845,77.118z'
                              />{' '}
                            </g>{' '}
                          </g>{' '}
                          <polygon
                            style={{ opacity: '0.08', fill: '#040000' }}
                            points='475.435,117.825 475.435,512 47.791,512 47.791,419.581 247.706,219.667 259.541,207.832 266.099,201.273 277.029,190.343 289.995,177.377 412.491,54.881 '
                          />{' '}
                          <polygon
                            style={{ fill: '#BBBBBA' }}
                            points='475.435,117.836 357.6,117.836 357.6,0 '
                          />{' '}
                          <g>
                            {' '}
                            <path
                              style={{ fill: '#B43331' }}
                              d='M414.376,370.658c-2.488-4.372-5.88-8.518-10.101-12.287c-3.467-3.166-7.538-6.106-12.137-8.82 c-18.543-10.93-45.003-16.207-80.961-16.207h-3.618c-1.96-1.809-3.996-3.618-6.106-5.503 c-13.644-12.287-24.499-25.63-32.942-40.48c16.583-36.561,24.499-69.126,23.519-96.867c-0.151-4.674-0.83-9.046-2.036-13.117 c-1.808-6.558-4.824-12.363-9.046-17.112c-0.075-0.075-0.075-0.075-0.15-0.151c-6.709-7.538-16.056-11.835-25.555-11.835 c-9.574,0-18.393,4.146-24.802,11.76c-6.331,7.538-9.724,17.866-9.875,30.002c-0.225,18.544,1.282,36.108,4.448,52.315 c0.301,1.282,0.528,2.563,0.829,3.844c3.166,14.7,7.84,28.645,13.871,41.611c-7.086,14.398-14.248,26.836-19.222,35.279 c-3.769,6.408-7.916,13.117-12.213,19.826c-19.373,3.468-35.807,7.689-50.129,12.966c-19.374,7.011-34.903,16.056-46.059,26.836 c-7.238,6.935-12.137,14.323-14.55,22.012c-2.563,7.915-2.411,15.83,0.453,22.916c2.638,6.558,7.387,12.061,13.719,15.83 c1.508,0.905,3.091,1.658,4.749,2.337c4.825,1.96,10.102,3.015,15.604,3.015c12.74,0,25.856-5.503,36.938-15.378 c20.654-18.469,41.988-48.169,54.576-66.94c10.327-1.583,21.559-2.94,34.224-4.297c14.927-1.508,28.118-2.412,40.104-2.865 c3.694,3.317,7.237,6.483,10.63,9.498c18.846,16.81,33.168,28.947,46.134,37.465c0,0.075,0.075,0.075,0.15,0.075 c5.127,3.392,10.026,6.181,14.926,8.443c5.502,2.563,11.081,3.92,16.81,3.92c7.237,0,14.021-2.186,19.675-6.181 c5.729-4.146,9.875-10.101,11.76-16.81C420.181,387.694,418.899,378.724,414.376,370.658z M247.706,219.667 c-1.056-9.348-1.508-19.072-1.357-29.324c0.15-9.724,3.694-16.283,8.895-16.283c3.919,0,8.066,3.543,9.951,10.327 c0.528,2.035,0.905,4.372,0.98,7.01c0.15,3.166,0.075,6.483-0.075,9.875c-0.452,9.574-2.112,19.75-4.976,30.681 c-1.734,7.011-3.995,14.323-6.784,21.936C251.173,243.186,248.911,231.803,247.706,219.667z M121.968,418.073 c-1.282-3.166,0.15-9.272,7.99-16.81c11.985-11.458,30.755-20.504,56.914-27.364c-4.976,6.784-9.875,12.966-14.625,18.619 c-7.237,8.744-14.172,16.132-20.429,21.71c-5.351,4.824-11.232,7.84-16.81,8.594c-0.98,0.151-1.96,0.226-2.94,0.226 C127.169,423.049,123.173,421.089,121.968,418.073z M242.428,337.942l0.528-0.829l-0.829,0.151 c0.15-0.377,0.377-0.754,0.602-1.055c3.167-5.352,7.161-12.212,11.458-20.127l0.377,0.829l0.98-2.035 c3.166,4.523,6.634,8.971,10.252,13.267c1.735,2.035,3.544,3.995,5.352,5.955l-1.205,0.075l1.055,0.98 c-3.09,0.226-6.331,0.528-9.573,0.829c-2.036,0.226-4.147,0.377-6.257,0.603C250.796,337.037,246.499,337.49,242.428,337.942z M369.298,384.98c-8.97-5.729-18.997-13.795-31.36-24.575c17.564,1.809,31.36,5.654,41.159,11.383 c4.297,2.488,7.538,5.051,9.724,7.538c3.619,3.844,4.901,7.312,4.221,9.649c-0.602,2.337-3.241,3.92-6.483,3.92 c-1.885,0-3.844-0.452-5.879-1.432c-3.468-1.658-7.086-3.694-10.931-6.181C369.598,385.282,369.448,385.131,369.298,384.98z'
                            />{' '}
                          </g>{' '}
                        </g>{' '}
                      </g>
                    </svg>
                  </div>
                  <div className='col-lg'>
                    <h5 className='fw-bold text-dark mb-0'>Order-Document.pdf</h5>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class='row justify-content-between'>
              <div class='col-auto'>
                <h4 className='text-primary fw-bold'>Job Amount</h4>
              </div>
              <div class='col-auto'>
                <h4 className='text-primary fw-bold'>${drivers?.job_amount ?? '-'}</h4>
              </div>
            </div>
            <hr />
            <h4 className='text-primary fw-bold mb-3'>Expenses</h4>
            {drivers?.expenses?.map((expense, index) => (
              <div key={index} class='row justify-content-between'>
                <div class='col-auto'>
                  <h5 className='text-primary fw-normal'>{expense?.expense_name}</h5>
                </div>
                <div class='col-auto'>
                  <h5 className='text-primary fw-normal'>${expense?.amount || 0}</h5>
                </div>
              </div>
            ))}
            <div class='row justify-content-between align-items-center'>
              <div class='col-auto'>
                <h4 className='text-primary fw-bold'>Total Amount</h4>
              </div>
              <div class='col-auto'>
                <h3 className='text-primary fw-bold'>
                  $
                  {drivers?.expenses?.reduce(
                    (total, expense) => total + (expense?.amount || 0),
                    drivers?.job_amount || 0
                  ) ?? '-'}
                </h3>
              </div>
            </div>
            <hr />
            <img src='/logo-original.svg' height={80} alt='' />
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='invoice-container'>
          <div className='invoice-header'>
            <h4>Trip Details</h4>
          </div>
          {/* Progress Bar */}
          <div className='progress-container'>
            <div
              className='progress'
              role='progressbar'
              aria-label='Invoice step progress'
              aria-valuenow={updateProgress()}
              aria-valuemin='0'
              aria-valuemax='100'
            >
              <div
                className='progress-bar bg-primary'
                style={{ width: `${updateProgress()}%` }}
              ></div>
            </div>
          </div>
          {/* Main Scrollable Content */}
          <div className='main-content'>
            <div id='invoice-stepper'>
              {/* Step 1: Parties Involved */}
              <div id='step-1' className={`step ${currentStep === 1 ? 'active' : ''}`}>
                <h5 className='step-title mt-4'>Step 1: Parties Involved</h5>
                <div className='step-content'>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-building me-2' />
                      Company
                    </h6>
                    <p>
                      <strong>Name:</strong> {drivers?.company_info?.company_name ?? '-'}
                    </p>
                    <p>
                      <strong>Email:</strong> {drivers?.company_info?.company_email ?? '-'}
                    </p>
                    <p>
                      <strong>Phone:</strong> {drivers?.company_info?.company_phone ?? '-'}
                    </p>
                    <p>
                      <strong>ID:</strong>{' '}
                      {drivers?.company_info?.id?.toString()?.padStart(3, '0') ?? '-'}
                    </p>
                  </div>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-person-check me-2' />
                      Driver
                    </h6>
                    <p>
                      <strong>Name:</strong> {drivers?.driver?.full_name ?? '-'}
                    </p>
                    <p>
                      <strong>Email:</strong> {drivers?.driver?.email ?? '-'}
                    </p>
                    <p>
                      <strong>Phone:</strong> {drivers?.driver?.phone ?? '-'}
                    </p>
                    <p>
                      <strong>ID:</strong>{' '}
                      {drivers?.driver?.id?.toString()?.padStart(3, '0') ?? '-'}
                    </p>
                  </div>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-building me-2' />
                      Factoring Company
                    </h6>
                    <p>
                      <strong>Name:</strong> {drivers?.factory_company?.company_name ?? '-'}
                    </p>
                    <p>
                      <strong>Email:</strong> {drivers?.factory_company?.email ?? '-'}
                    </p>
                    <p>
                      <strong>Phone:</strong> {drivers?.factory_company?.phone ?? '-'}
                    </p>
                    <p>
                      <strong>ID:</strong>{' '}
                      {drivers?.factory_company?.id?.toString()?.padStart(3, '0') ?? '-'}
                    </p>
                  </div>
                </div>
              </div>
              {/* Step 2: Job & Time Details */}
              <div id='step-2' className={`step ${currentStep === 2 ? 'active' : ''}`}>
                <h5 className='step-title mt-4'>Step 2: Trip &amp; Time Stamps</h5>
                <div className='step-content'>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-briefcase-fill me-2' />
                      Trip Details
                    </h6>
                    <p>
                      <strong>Title:</strong> {drivers?.job_title ?? '-'}
                    </p>
                    <p>
                      <strong>Transit:</strong> {drivers?.transit ?? '-'}
                    </p>
                    <p>
                      <strong>Emptyrepo:</strong> {drivers?.emptyrepo ?? '-'}
                    </p>
                    <p>
                      <strong>Estimated Miles:</strong> {drivers?.estimated_miles ?? '-'}
                    </p>
                    <p>
                      <strong>Estimated Dollar Per Mile:</strong>{' '}
                      {drivers?.estimated_dollar_per_mile ?? '-'}
                    </p>
                    <p>
                      <strong>Trip Assigned:</strong> {drivers?.job_start_datetime ?? '-'}
                    </p>
                    <p>
                      <strong>Trip Start:</strong> {drivers?.job_start_datetime ?? '-'}
                    </p>
                    <p>
                      <strong>Trip End:</strong> {drivers?.job_start_datetime ?? '-'}
                    </p>
                  </div>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-stopwatch-fill me-2' />
                      Time Stamps
                    </h6>
                    <p>
                      <strong>Trip Start:</strong> 28-06-2020 16:20
                    </p>
                    <p>
                      <strong>Pickup:</strong> 28-06-2020 16:20
                    </p>
                    <p>
                      <strong>Dropoff:</strong> 30-06-2020 16:20
                    </p>
                    <p>
                      <strong>Trip End:</strong> 30-06-2020 16:20
                    </p>
                  </div>
                </div>
              </div>
              {/* Step 3: Locations & Documents */}
              <div id='step-3' className={`step ${currentStep === 3 ? 'active' : ''}`}>
                <h5 className='step-title mt-4'>Step 3: Locations</h5>
                <div className='step-content'>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-box-arrow-up me-2' />
                      Shipper / Pick Up
                    </h6>
                    <p>
                      <strong>Date & Time:</strong> {drivers?.drop_datetime ?? '-'}
                    </p>
                    <p>
                      <strong>Facility Ref Name:</strong> {drivers?.pickup_person_name ?? '-'}
                    </p>
                    <p>
                      <strong>Facility Ref Contact:</strong> {drivers?.pickup_person_phone ?? '-'}
                    </p>
                    <p>
                      <strong>Address:</strong> {drivers?.pickup_address ?? '-'}
                    </p>
                    {/*{drivers?.job_trip_documents?.filter((item) => item.type == 'PICKUP')?.map((doc, index) => (*/}
                    {/*    <React.Fragment key={index}>*/}
                    {/*        {doc?.submitted_attachment && doc?.submitted_attachment?.map((attachment, index) => (*/}
                    {/*            <React.Fragment key={index}>*/}
                    {/*                {attachment && (*/}
                    {/*                    <a href={`${process.env.REACT_APP_API_BASE_URL}storage/${attachment}`} target="_blank" className="document-link mb-2">*/}
                    {/*                        <i className="bi bi-file-earmark-fill"/>*/}
                    {/*                        <span>{attachment?.split('/')[attachment?.split('/')?.length - 1]}</span>*/}

                    {/*                    </a>*/}
                    {/*                )}*/}
                    {/*            </React.Fragment>*/}
                    {/*        ))}*/}
                    {/*    </React.Fragment>*/}
                    {/*))}*/}
                  </div>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-box-arrow-down me-2' />
                      Receiver / Drop Off
                    </h6>
                    <p>
                      <strong>Date & Time:</strong> {drivers?.drop_datetime ?? '-'}
                    </p>
                    <p>
                      <strong>Facility Ref Name:</strong> {drivers?.drop_person_name ?? '-'}
                    </p>
                    <p>
                      <strong>Facility Ref Contact:</strong> {drivers?.drop_person_phone ?? '-'}
                    </p>
                    <p>
                      <strong>Address:</strong> {drivers?.drop_address ?? '-'}
                    </p>
                  </div>
                </div>
              </div>
              {/* Step 4: Financials */}
              <div id='step-4' className={`step ${currentStep === 4 ? 'active' : ''}`}>
                {/* ✅ Step Title + Download Button */}
                <div className='d-flex align-items-center justify-content-center mt-4 my-3'>
                  <h5 className='step-title mb-0' style={{ whiteSpace: 'nowrap' }}>
                    Step 4: Rate Confirmation &amp; Documents
                  </h5>
                  <Button
                    type='primary'
                    style={{
                      padding: '2px 8px',
                      fontSize: '10px',
                      height: '28px',
                      whiteSpace: 'nowrap',
                    }}
                    onClick={() => {
                      const urls = []
                      urls.push(FILES_URL + drivers?.rate_confirmation_document)
                      drivers?.job_trip_documents
                        ?.filter(item => item.type === 'DROPOFF')
                        .map(doc => {
                          urls.push(FILES_URL + doc?.submitted_attachment)
                        })
                      downloadAllFiles(urls)
                    }}
                    loading={isFetching}
                  >
                    Download All
                  </Button>
                </div>

                <div className='step-content'>
                  <div className='info-card'>
                    <h6>
                      <i className='bi bi-patch-check-fill me-2' />
                      Rate Confirmation
                    </h6>

                    {drivers?.rate_confirmation_document && (
                      <a
                        href={drivers?.rate_confirmation_document_url || void 0}
                        target='_blank'
                        rel='noreferrer'
                        className='document-link mb-2'
                      >
                        <i className='bi bi-file-earmark-pdf-fill' />
                        <span>
                          {
                            drivers?.rate_confirmation_document?.split('/')[
                              drivers?.rate_confirmation_document?.split('/')?.length - 1
                            ]
                          }
                        </span>
                      </a>
                    )}
                  </div>
                  <div className='info-card'>
                    <h6>
                      <i class='bi bi-file-check-fill me-2'></i>
                      POD/Receipts
                    </h6>

                    <div className='row w-100 justify-content-between g-3 drop-off-card-overlay'>
                      {drivers?.job_trip_documents
                        ?.filter(item => item.type === 'DROPOFF')
                        ?.map((doc, index) => (
                          <div
                            key={index}
                            className='border rounded-3 d-flex align-items-center justify-content-center overflow-hidden'
                            style={{ width: '200px', height: '200px', cursor: 'pointer' }}
                            onClick={() => handleShow(doc?.submitted_attachment_url)}
                          >
                            <img
                              src={doc?.submitted_attachment_url}
                              alt={`Image ${index + 1}`}
                              className='img-fluid h-100 w-100 object-fit-cover'
                            />
                          </div>
                        ))}

                      {/* Popup Modal */}
                      <Modal show={show} onHide={handleClose} centered size='md'>
                        <Modal.Header closeButton className='border-0'>
                          x
                        </Modal.Header>
                        <Modal.Body className='d-flex justify-content-center align-items-center'>
                          <img
                            src={previewImg}
                            alt='Preview'
                            className='img-fluid'
                            style={{ maxHeight: '60vh', width: '100%' }}
                          />
                        </Modal.Body>
                      </Modal>
                    </div>
                  </div>
                </div>
              </div>
              {/* Step 5: Confirmation */}
              <div id='step-5' className={`step ${currentStep === 5 ? 'active' : ''}`}>
                <h5 className='step-title mt-4'>Step 5: Confirmation &amp; Total</h5>
                <div className='step-content'>
                  <div className='total-amount-card mt-3'>
                    <h3>Gross Amount</h3>
                    <div className='amount'>
                      $
                      {parseFloat(
                        drivers?.expenses?.reduce(
                          (total, expense) => total + (expense?.amount || 0),
                          drivers?.job_amount || 0
                        ) ?? 0
                      )?.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Bottom Tab Navigation */}
          <nav className='bottom-tab-nav'>
            <a
              href='#'
              className={`tab-item ${currentStep === 1 ? 'active' : ''}`}
              data-step={1}
              onClick={e => {
                e.preventDefault()
                handleTabClick(1)
              }}
            >
              <i className='bi bi-people' />
              <span className='tab-label'>Parties</span>
            </a>
            <a
              href='#'
              className={`tab-item ${currentStep === 2 ? 'active' : ''}`}
              data-step={2}
              onClick={e => {
                e.preventDefault()
                handleTabClick(2)
              }}
            >
              <i className='bi bi-card-list' />
              <span className='tab-label'>Trip</span>
            </a>
            <a
              href='#'
              className={`tab-item ${currentStep === 3 ? 'active' : ''}`}
              data-step={3}
              onClick={e => {
                e.preventDefault()
                handleTabClick(3)
              }}
            >
              <i className='bi bi-geo-alt' />
              <span className='tab-label'>Location</span>
            </a>
            <a
              href='#'
              className={`tab-item ${currentStep === 4 ? 'active' : ''}`}
              data-step={4}
              onClick={e => {
                e.preventDefault()
                handleTabClick(4)
              }}
            >
              <i class='bi bi-file-check-fill '></i>
              <span className='tab-label'>Documents</span>
            </a>
            <a
              href='#'
              className={`tab-item ${currentStep === 5 ? 'active' : ''}`}
              data-step={5}
              onClick={e => {
                e.preventDefault()
                handleTabClick(5)
              }}
            >
              <i className='bi bi-currency-dollar' />
              <span className='tab-label'>Amount</span>
            </a>
          </nav>
        </div>
      </div>
    </>
  )
}

export default InvoicePage
